import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledTableServiceCivilStatusMenu } from 'shell/view-models/disabled-menu';

interface TableServiceMenuProps {
  visibility?: DisabledTableServiceCivilStatusMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const TableServiceMenu = ({
  visibility = {
    serie: true,
    registry: true,
    annotation: true,
    stamp: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: TableServiceMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle di servizio" />
      </ListItem>
      <Menu
        id="table-service-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.stamp
          ? [
              <MenuItem
                key="stamp-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/stato-civile/timbri');
                }}
              >
                <Typography variant="inherit">Timbri e diciture certificati</Typography>
              </MenuItem>,
              <Divider
                key="stamp-divider"
                hidden={!visibility.annotation && !visibility.registry && !visibility.serie}
              />,
            ]
          : undefined}
        {visibility.annotation
          ? [
              <MenuItem
                key="annotation-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/stato-civile/annotazioni');
                }}
              >
                <Typography variant="inherit">Testo annotazioni</Typography>
              </MenuItem>,
              <Divider
                key="annotation-divider"
                hidden={!visibility.registry && !visibility.serie}
              />,
            ]
          : undefined}
        {visibility.registry
          ? [
              <MenuItem
                key="registry-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/stato-civile/registri');
                }}
              >
                <Typography variant="inherit">Registri</Typography>
              </MenuItem>,
              <Divider key="registry-divider" hidden={!visibility.serie} />,
            ]
          : undefined}
        {visibility.serie
          ? [
              <MenuItem
                key="serie-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/stato-civile/serie');
                }}
              >
                <Typography variant="inherit">Transcodifica Serie Content Manager</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

TableServiceMenu.displayName = 'Table Service Menu';

export default TableServiceMenu;
